$( document ).ready(function() {
    $(".vb-image-with-text-icon p").append('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.96364 0.792175H10.2385C10.4661 0.820954 10.6941 0.845884 10.9209 0.878879C12.8147 1.1553 14.4931 1.91016 15.9259 3.179C17.6659 4.71877 18.7263 6.6411 19.0887 8.94122C19.1312 9.21086 19.1631 9.48233 19.2 9.75308V11.0278C19.171 11.2558 19.1472 11.4844 19.1127 11.7115C18.729 14.2424 17.5524 16.3281 15.5445 17.9149C13.4166 19.5968 10.9796 20.2583 8.29558 19.8961C5.75863 19.5535 3.67561 18.351 2.08448 16.3457C0.394703 14.2149 -0.258142 11.774 0.0911059 9.08218C0.337504 7.18313 1.11465 5.5057 2.38404 4.07023C3.92495 2.32791 5.84902 1.26566 8.15112 0.903443C8.42153 0.860916 8.69305 0.82902 8.96364 0.792175ZM8.14397 11.9922L8.09318 11.9577C8.08226 11.9518 8.07184 11.9451 8.06202 11.9375C7.601 11.5159 7.14004 11.0943 6.67914 10.6727C6.27288 10.3024 5.87872 9.91713 5.45375 9.5694C4.93566 9.14523 4.15081 9.41579 3.99205 10.0603C3.8936 10.4592 4.01991 10.7935 4.32479 11.0707C5.36123 12.0116 6.39577 12.9541 7.42842 13.8982C7.92653 14.3526 8.43161 14.3438 8.91341 13.8659C10.9007 11.8944 12.8875 9.92251 14.8737 7.95027C14.9365 7.88943 14.9951 7.82445 15.0492 7.75578C15.4494 7.23262 15.2079 6.46017 14.5787 6.2633C14.1571 6.13132 13.8152 6.2721 13.5125 6.57602C11.7697 8.32354 10.0251 10.0693 8.27872 11.8133C8.22628 11.8659 8.18852 11.9326 8.14397 11.9927V11.9922Z" fill="black"/></svg>');
   //$(".accordion__button").click(function(){ 
   
  
  $('.vb-logo-list').slick({
  autoplay: true,
  infinite: true,
  autoplaySpeed: 0,
  slidesToScroll: 1,
  slidesToShow: 6,
  arrows: false,
  centerMode: true,   
  cssEase: 'linear',
  speed: 10000,
  //initialSlide: 1,
  draggable: false,
  //pauseOnHover: true,
    		 responsive: [
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
  ]
  });

if (window.matchMedia("(max-width: 1023px)").matches) {
$('.text-with-icon-slider-m').slick({
        infinite: true,
        speed: 300,
        autoplay: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        centerMode: true,
        arrows: false,
        prevArrow: $('.prev-graam'),
        nextArrow: $('.next-graam'),
		 responsive: [
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
  ]
});
}
   if (window.matchMedia("(min-width: 1024px)").matches) {

  //document.querySelector('.vb-button-text-btn a').addEventListener('click', function (){
  $(".vb-button-text-btn a").click(function(){    
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcMZ88']);
	});
  //document.querySelector('a.text-with-image-main-one-btn').addEventListener('click', function (){
  $("a.text-with-image-main-one-btn").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcMZ88']);
	});
  $("a.vb-video-btn-tx").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcMZ88']);
	});
  
  $(".vb-block__featured-promo a.button").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcMZ88']);
	});
   }
  
  if (window.matchMedia("(max-width: 1023px)").matches) {

  //document.querySelector('.vb-button-text-btn a').addEventListener('click', function (){
  $(".vb-button-text-btn a").click(function(){    
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Yt2htt']);
	});
  //document.querySelector('a.text-with-image-main-one-btn').addEventListener('click', function (){
  $("a.text-with-image-main-one-btn").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Yt2htt']);
	});
  $("a.vb-video-btn-tx").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Yt2htt']);
	});
  
  $(".vb-block__featured-promo a.button").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Yt2htt']);
	});

  }

  $(document).ready(function(){ 
        setTimeout(function(){
        //  $(".vb-image-hide").show(); // Hide the message after 3 seconds
        $('.product-gallery').css({"opacity": "1"});
      }, 2000); // 3000 milliseconds = 3 seconds
  }); 


});

window.setTimeout(function(){
   if (window.matchMedia('(max-width: 767px)').matches) {
    if(window.location.hash){
        var $target  = $(window.location.hash).closest("#vb-video-main");
        if($target.length)
            $('html, body').animate({scrollTop: $target.offset().top  - 300 }, 1000);
    }
  }
}, 1000);
